/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssignLearningToLearningDTO
 */
export interface AssignLearningToLearningDTO {
    /**
     * 
     * @type {Array<string>}
     * @memberof AssignLearningToLearningDTO
     */
    targetLearningIds?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof AssignLearningToLearningDTO
     */
    sourceLearningId?: string;
}

export function AssignLearningToLearningDTOFromJSON(json: any): AssignLearningToLearningDTO {
    return AssignLearningToLearningDTOFromJSONTyped(json, false);
}

export function AssignLearningToLearningDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssignLearningToLearningDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'targetLearningIds': !exists(json, 'targetLearningIds') ? undefined : json['targetLearningIds'],
        'sourceLearningId': !exists(json, 'sourceLearningId') ? undefined : json['sourceLearningId'],
    };
}

export function AssignLearningToLearningDTOToJSON(value?: AssignLearningToLearningDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'targetLearningIds': value.targetLearningIds,
        'sourceLearningId': value.sourceLearningId,
    };
}

